import { render, staticRenderFns } from "./EditBulkCourse.vue?vue&type=template&id=eba2f3f8&lang=pug"
import script from "./EditBulkCourse.vue?vue&type=script&lang=js"
export * from "./EditBulkCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports